// src/pages/financeiro/DashboardFinanceiro.jsx
import useFinanceiro from "../../hooks/useFinanceiro";
import { formatarMoeda } from "../../utils/formatarMoeda";

export default function DashboardFinanceiro() {
  const { resumo } = useFinanceiro();

  return (
    <div>
      <h1>DASHBOARD FINANCEIRO</h1>
      <hr />

      <div style={{ display: "flex", gap: 20 }}>

        <div>
          <h3>Recebido</h3>
          <p>R$ {formatarMoeda(resumo?.totalRecebido || 0)}</p>
        </div>

        <div>
          <h3>A Receber</h3>
          <p>R$ {formatarMoeda(resumo?.totalAReceber || 0)}</p>
        </div>

      </div>
    </div>
  );
}